import { Col } from '@amzn/stencil-react-components/layout';
import { RequiredLabel } from '../../../shared/ui/forms/RequiredLabel';
import {
  OptionSelect,
  type OptionSelectItem,
} from '../../../shared/ui/forms/OptionSelect';

export interface FormSelectFieldProps {
  readonly label: string;
  readonly options: readonly OptionSelectItem[];
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly placeholder: string;
  readonly disabled?: boolean;
  readonly hasError?: boolean;
  readonly dataTestId?: string;
}

/**
 * Required form select field: {@link RequiredLabel} above a
 * {@link OptionSelect}. Used in CreateAuditSheet to reduce repetition
 * across location, division, template, and audit type fields.
 *
 * The Select configuration itself lives in {@link OptionSelect} so
 * this field, the NA-reason picker, the data-collection field, and the
 * language picker all share one copy.
 */
export function FormSelectField({
  label,
  options,
  value,
  onChange,
  placeholder,
  disabled = false,
  hasError = false,
  dataTestId,
}: FormSelectFieldProps): JSX.Element {
  return (
    <Col gridGap="dimensions.spacing.100">
      <RequiredLabel isRequired hasError={hasError}>
        {label}
      </RequiredLabel>
      <OptionSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        hasError={hasError}
        ariaLabel={label}
        isRequired
        dataTestId={dataTestId}
      />
    </Col>
  );
}
